import React, { useEffect, useState } from 'react'
import { Table, Input ,Spin} from 'antd'
import './Dashboard.css'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { DashboardList } from '../../AllAPI/AdminAPI'

export default function Dashboard() {
  const navigate = useNavigate()
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')
  const [loading, setLoading] = useState(false)

  // ------------------- Disable Back Button -------------------

  useEffect(() => {
    // Push a dummy state
    window.history.pushState(null, null, window.location.href)

    const handlePopState = () => {
      // Push forward again
      window.history.pushState(null, null, window.location.href)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  // ------------------- State for dashboard stats -------------------
  const [dashboardData, setDashboardData] = useState([])

  // ------------------- Fetch API Data -------------------
  const fetchDashboardData = async () => {
    try {
      setLoading(true)
       
      const response = await axios.get(
        `${DashboardList}/${storedBranchId}/${BoardingYear}`,
      )

      setDashboardData(response.data)
    } catch (error) {
      console.error('Dashboard Data Error:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDashboardData()
  }, [])


  return (
    <div className="dashboard-container">
      <div className="row p-0 m-0 pb-5" style={{ backgroundColor: '#f2f7fd' }}>
        <div className="col-12 col-md-1"></div>
        <div className="col-12 col-md-10 p-md-5" >
        <Spin spinning={loading} tip="Loading dashboard...">
          <div className="row p-0 px-md-5 m-0 mb-5 pt-3 pt-md-0">
          {/* =============Pending Count============== */}

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-green">
                <h4>Apprv. Pending Reg Fee (Count)</h4>
                <p className="stat-number">
                  {dashboardData.totalRegistrationFeePendingCount || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-green">
                <h4>Apprv. Pending Hostel Fee (Count)</h4>
                <p className="stat-number">
                  {dashboardData.totalHostelFeePendingCount || 0}
                </p>
              </div>
            </div>

           <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-green">
                <h4>Apprv. Pending Leaves (Count)</h4>
                <p className="stat-number">
                  {dashboardData.pendingLeaveCount || 0}
                </p>
              </div>
            </div>

             <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-green">
                <h4>Apprv. Pending Complaints (Count)</h4>
                <p className="stat-number">
                  {dashboardData.pendingComplaints || 0}
                </p>
              </div>
            </div>


          {/* =============Todays Count============== */}

           
            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-blue">
                <h4>Todays Hostel Fee (Rs.)</h4>
                <p className="stat-number">
                  {dashboardData.todayHostelFee || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-blue">
                <h4>Todays Registration Fee (Rs.)</h4>
                <p className="stat-number">
                  {dashboardData.todayRegistrationFee || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-blue">
                <h4>Todays Registration (Count)</h4>
                <p className="stat-number">
                  {dashboardData.todayRegistrationCount || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-blue">
                <h4>Todays Leave (Count)</h4>
                <p className="stat-number">
                  {dashboardData.todayLeaveCount || 0}
                </p>
              </div>
            </div>


          {/* =============Total Count============== */}

           <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-orange">
                <h4>Total Hostel Fee Approved (Count)</h4>
                <p className="stat-number">
                  {dashboardData.totalHostelFeeApprovedCount || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-orange">
                <h4>Total Hostel Fee (Rs.)</h4>
                <p className="stat-number">
                  {dashboardData.totalHostelFee || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-orange">
                <h4>Total Registration Fee (Rs.)</h4>
                <p className="stat-number">
                  {dashboardData.totalRegistrationFee || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-orange">
                <h4>Total Concession Amount (Rs.)</h4>
                <p className="stat-number">
                  {dashboardData.totalConcessionAmts || 0}
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-4">
              <div className="stat-card grad-orange">
                <h4>Total Available Beds (Count)</h4>
                <p className="stat-number">
                  {dashboardData.availableBedCount || 0}
                </p>
              </div>
            </div>
          
          </div>
          </Spin>
        </div>
        <div className="col-12 col-md-1"></div>
      </div>
    </div>
  )
}
